import React from 'react';
import { Reveal } from '../ui/Reveal';
import { PhotoSlot } from '../ui/PhotoSlot';
export function AboutSection() {
  return <section id="about" aria-labelledby="about-heading" className="bg-brand-mist" data-id="element-59" data-mp="chhyhejsyqsd">
      <div className="px-fluid py-section grid items-center gap-fluid lg:grid-cols-12" data-id="element-60" data-mp="hezwi9wa7lll">
        <Reveal className="lg:col-span-5" data-id="element-61" data-mp="lhwkkg4lc9wx">
          <PhotoSlot alt="David Moceri" label="Photo · 4:5" className="radius-fluid aspect-[4/5] max-h-[85svh]" data-id="element-62" data-mp="lfju1ekror89" />
        </Reveal>
        <div className="lg:col-span-7" data-id="element-63" data-mp="vej3gzdcwqwb">
          <Reveal data-id="element-64" data-mp="vdhkm8q3n041">
            <h2 id="about-heading" className="text-h2 max-w-[18ch] font-extrabold text-brand-navy" data-id="element-65" data-mp="1060uaulo1b3k">
              Born in Mount Clemens. Raised in Detroit.
            </h2>
          </Reveal>
          <Reveal delay={0.05} data-id="element-66" data-mp="197iiz1d52l3v">
            <div className="text-body-fluid mt-[clamp(1.75rem,2.5vw,3rem)] max-w-[62ch] space-y-6" data-id="element-67" data-mp="198a39g1acweu">
              <p data-id="element-68" data-mp="1e7d7iy9fyylr">
                I grew up in Detroit, Michigan, and went to high school at De La Salle and Utica Eisenhower. When I was
                younger I got in some trouble and had to turn my life around — and I did. That’s exactly why I care so
                much about helping other people find their direction and believe in themselves.
              </p>
              <p data-id="element-69" data-mp="zn5ykjmo9u1e">
                For 30 years I’ve been in marketing — from the early days of email and mobile to automation, and now AI.{' '}
                <strong className="font-bold text-brand-slate" data-id="element-70" data-mp="1x9v9xk39lizx">I’m direct, I’m loud, and I don’t do BS.</strong> Over the
                last two years I’ve gone all-in on AI, and I put myself at the top of my peers when it comes to actually
                implementing it inside real businesses so they run smoother and make more money.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}